import React from "react";
import { SectionHeading } from "../SectionHeading";
import { TransformCta } from "../TransformCta";
const factors = ["Medical history", "Current treatments", "Risk factors", "Laboratory findings", "Individual patient needs"];
export function Problem() {
  return <section className="bg-white px-5 py-16" data-id="element-239" data-mp="2rm2af3mqu24u">
      <SectionHeading eyebrow="A more structured approach to diabetes care" title={<>
            The challenge isn't simply knowing the guidelines. It's <em className="text-brand" data-id="element-241" data-mp="2cqmlfd10swfb">finding the right information</em> when you need it.
          </>} data-id="element-240" data-mp="2mo950ct9lc5m" />
      <div className="mx-auto mt-8 max-w-2xl" data-id="element-242" data-mp="28qkhex7tbqwv">
        <p className="text-center text-lg leading-relaxed text-ink" data-id="element-243" data-mp="28rn9v9ksa1ew">Every consultation presents a different combination of:</p>
        <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-244" data-mp="6xwaacs1sjbt">
          {factors.map(f => <li key={f} className="rounded-full bg-brandsoft px-4 py-2 text-[15px] font-semibold text-navy" data-id="element-245" data-mp="1zcpwgt3rflk">
              {f}
            </li>)}
        </ul>
        <p className="mt-6 text-center text-lg leading-relaxed text-muted" data-id="element-246" data-mp="14d6b1ec7mcvq">
          That complexity can make it difficult to organize information efficiently, especially when time is limited.
        </p>
        <p className="mt-6 rounded-2xl bg-navy p-6 text-center font-serif text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-247" data-mp="vcqe6npz23zu">
          Diabetes Clinical Blueprint was created to help you approach these situations with a clearer structure.
        </p>
      </div>
      <TransformCta label="I want a clearer structure today" data-id="element-248" data-mp="1s04rwd48rmu6" />
    </section>;
}